<app-shared-overview title="{{ 'TOURNAMENT.TOURNAMENT-CENTRAL' | translate }}"></app-shared-overview>
<div class="container py-3" [nbSpinner]="loading">
    <app-back-button class="mb-3" text="{{ 'BUTTONS.BACK-HOMEPAGE' | translate }}"></app-back-button>
    <nb-card>
        <nb-card-body class="py-4">
            <div class="row">
                <div class="col-lg-3">
                    <app-filter-sidebar [filters]="filters" (onChange)="onFiltersChange($event)"></app-filter-sidebar>
                </div>
                <div class="col-lg-9">
                    <div class="tournaments">
                        <div *ngFor="let month of tournamentsMonths" class="tournaments-months">
                            <p class="tournaments-month__title">{{ month.description }}</p>
                            <hr class="divider" />
                            <div class="row">
                                <div class="col-lg-4" *ngFor="let tournament of month.tournaments">
                                    <app-tournament-card [tournament]="tournament"></app-tournament-card>
                                </div>
                            </div>
                        </div>
                        <nb-card class="no-results" *ngIf="!tournamentsMonths && statusCode === 0">
                            <nb-card-body>
                                <svg
                                    width="84px"
                                    height="84px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.5776 14.5419C15.5805 13.53 16.2 12.1373 16.2 10.6C16.2 7.50721 13.6928 5 10.6 5C7.50721 5 5 7.50721 5 10.6C5 13.6928 7.50721 16.2 10.6 16.2C12.1555 16.2 13.5628 15.5658 14.5776 14.5419ZM14.5776 14.5419L19 19M8.5 8.5L12.5 12.5M12.5 8.5L8.5 12.5"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <p class="paragraph-1">{{ "MESSAGE.RESULT.NO-RESULTS" | translate }}</p>
                            </nb-card-body>
                        </nb-card>
                    </div>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</div>
